// Mock data for LUVCORP website

export const companyInfo = {
  name: 'LUVCORP SOLUÇÕES PREDIAIS',
  phone: '21 98736 1748',
  whatsapp: '5521987361748',
  email: 'luvcorpsolucoes@gmail.com',
  address: 'Rua Augusto Nunes 494, Rio de Janeiro',
  instagram: '@LUVCORP_',
  instagramUrl: 'https://instagram.com/luvcorp_'
};

export const services = [
  {
    id: 1,
    title: 'Reforma de Fachada',
    description: 'Melhora estética e funcional de fachadas. Valoriza o imóvel e protege contra intempéries.',
    icon: 'Building2',
    featured: true,
    details: [
      'Pintura profissional de fachadas',
      'Impermeabilização completa',
      'Reparos estruturais',
      'Tratamento contra infiltrações',
      'Modernização estética'
    ]
  },
  {
    id: 2,
    title: 'Hidráulica',
    description: 'Instalações e reparos hidráulicos com garantia de eficiência e durabilidade. Atendimento 24h para emergências.',
    icon: 'Droplets',
    details: [
      'Instalação e reparo de tubulações',
      'Manutenção de sistemas hidráulicos',
      'Caça vazamentos com tecnologia',
      'Atendimento emergencial 24h',
      'Evita vazamentos e danos estruturais'
    ]
  },
  {
    id: 3,
    title: 'Elétrica',
    description: 'Instalação, manutenção e reparos de sistemas elétricos. Garante segurança e funcionalidade para qualquer projeto.',
    icon: 'Zap',
    details: [
      'Instalação de sistemas elétricos',
      'Manutenção preventiva e corretiva',
      'Quadros de distribuição',
      'Atendimento emergencial 24h',
      'Segurança garantida'
    ]
  },
  {
    id: 4,
    title: 'Impermeabilizações',
    description: 'Impermeabilização de caixas d\'água, cisternas, lajes e calhas. Oferece proteção contra infiltrações e danos.',
    icon: 'Shield',
    details: [
      'Impermeabilização de lajes',
      'Caixas d\'água e cisternas',
      'Calhas e coberturas',
      'Proteção contra infiltrações',
      'Garantia de durabilidade'
    ]
  },
  {
    id: 5,
    title: 'Pintura e Alvenaria',
    description: 'Pintura profissional e execução de obras em alvenaria com acabamento impecável.',
    icon: 'Paintbrush',
    details: [
      'Pintura interna e externa',
      'Textura e grafiato',
      'Obras de alvenaria geral',
      'Acabamento profissional',
      'Materiais de primeira linha'
    ]
  },
  {
    id: 6,
    title: 'Teste de Percussão',
    description: 'Diagnóstico estrutural por percussão técnica. Identifica problemas precocemente e evita grandes danos.',
    icon: 'Search',
    details: [
      'Diagnóstico estrutural preciso',
      'Identificação de fissuras',
      'Análise de revestimentos',
      'Prevenção de danos maiores',
      'Relatório técnico detalhado'
    ]
  },
  {
    id: 7,
    title: 'Manutenção de Telhados',
    description: 'Reparos e manutenção preventiva em coberturas. Garante segurança e eficiência no sistema de cobertura.',
    icon: 'Home',
    details: [
      'Troca e reparo de telhas',
      'Manutenção preventiva',
      'Impermeabilização de coberturas',
      'Calhas e rufos',
      'Garantia de segurança'
    ]
  },
  {
    id: 8,
    title: 'Inspeção Aérea com Drone 4K',
    description: 'Tecnologia que leva seu projeto a outro nível. Inspeções de telhados, fachadas e calhas sem necessidade de andaimes.',
    icon: 'Drone',
    featured: true,
    details: [
      'Inspeção de áreas difíceis',
      'Imagens 4K de alta qualidade',
      'Redução de riscos de acidentes',
      'Relatórios técnicos detalhados',
      'Diagnóstico preventivo preciso'
    ]
  },
  {
    id: 9,
    title: 'Desentupimento de Esgoto',
    description: 'Solução eficaz para obstruções no esgoto. Resolução imediata e limpeza garantida.',
    icon: 'Wrench',
    details: [
      'Desentupimento de tubulações',
      'Limpeza de ralos e pias',
      'Equipamentos modernos',
      'Atendimento rápido',
      'Garantia de serviço'
    ]
  },
  {
    id: 10,
    title: 'Limpeza de Caixa de Gordura',
    description: 'Manutenção preventiva de caixas de gordura. Evita entupimentos e odores.',
    icon: 'Droplet',
    details: [
      'Limpeza completa',
      'Manutenção preventiva',
      'Evita entupimentos',
      'Eliminação de odores',
      'Atendimento regular'
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: 'Condomínio ML Renha',
    location: 'Paissandu 159, Flamengo - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 2,
    title: 'Condomínio Solar Príncipe Márcio',
    location: 'Rua Nascimento e Silva 183, Ipanema - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 3,
    title: 'Condomínio Vermont',
    location: 'Rua Barão de Jaguaripe 55, Ipanema - Rio de Janeiro',
    category: 'Manutenção Predial',
    year: ''
  },
  {
    id: 4,
    title: 'Condomínio Locarno',
    location: 'Av Oswaldo Cruz 86, Flamengo - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 5,
    title: 'Condomínio Meson',
    location: 'Av Oswaldo Cruz 123, Flamengo - Rio de Janeiro',
    category: 'Impermeabilizações',
    year: ''
  },
  {
    id: 6,
    title: 'Condomínio Garagem',
    location: 'Av Oswaldo Cruz 78, Flamengo - Rio de Janeiro',
    category: 'Manutenção Predial',
    year: ''
  },
  {
    id: 7,
    title: 'Condomínio Jannuzzi',
    location: 'Av Atlântica 1918, Copacabana - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 8,
    title: 'Condomínio Paulo Henrique',
    location: 'Rua Cinco de Julho 223, Copacabana - Rio de Janeiro',
    category: 'Hidráulica',
    year: ''
  },
  {
    id: 9,
    title: 'Condomínio Reigadas',
    location: 'Rua Barão da Torre 571, Ipanema - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 10,
    title: 'Condomínio Percy Lau',
    location: 'Rua Humberto de Campos 756, Leblon - Rio de Janeiro',
    category: 'Pintura e Alvenaria',
    year: ''
  },
  {
    id: 11,
    title: 'Condomínio Santo Agostinho',
    location: 'Rua José de Linhares 130, Leblon - Rio de Janeiro',
    category: 'Impermeabilizações',
    year: ''
  },
  {
    id: 12,
    title: 'Condomínio Silva Campos',
    location: 'Rua Barão de Ipanema 140, Copacabana - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 13,
    title: 'Condomínio Maria Angélica',
    location: 'Rua Maria Angélica 451, Jardim Botânico - Rio de Janeiro',
    category: 'Elétrica',
    year: ''
  },
  {
    id: 14,
    title: 'Condomínio Maria Rosa',
    location: 'Rua Araucária 150, Jardim Botânico - Rio de Janeiro',
    category: 'Manutenção de Telhados',
    year: ''
  },
  {
    id: 15,
    title: 'Condomínio Colina',
    location: 'Rua Maria Angélica 758, Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 16,
    title: 'Condomínio Renoir',
    location: 'Rua Carijós 35, Méier - Rio de Janeiro',
    category: 'Pintura e Alvenaria',
    year: ''
  },
  {
    id: 17,
    title: 'Condomínio Maria José',
    location: 'Rua Dona Claudina 91, Méier - Rio de Janeiro',
    category: 'Hidráulica',
    year: ''
  },
  {
    id: 18,
    title: 'Condomínio Master Business',
    location: 'Rua Silva Rabelo 57, Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 19,
    title: 'Condomínio Mirante de Toledo',
    location: 'Rua Vaz de Toledo 217, Engenho Novo - Rio de Janeiro',
    category: 'Impermeabilizações',
    year: ''
  },
  {
    id: 20,
    title: 'Condomínio Prudente de Morais',
    location: 'Av Prudente de Morais 739, Ipanema - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 21,
    title: 'Condomínio Prentice Mulford',
    location: 'Rua Vinícius de Morais 27, Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 22,
    title: 'Condomínio Darque de Mattos',
    location: 'Rua Darque de Matos 196, Higienópolis - Rio de Janeiro',
    category: 'Manutenção Predial',
    year: ''
  },
  {
    id: 23,
    title: 'Condomínio Monalisa',
    location: 'Rua Jorge Yunes 400, Recreio - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 24,
    title: 'Condomínio Novo Oceano',
    location: 'Rua Jorge Yunes 174, Recreio - Rio de Janeiro',
    category: 'Impermeabilizações',
    year: ''
  },
  {
    id: 25,
    title: 'Condomínio Porto Fino',
    location: 'Rua John Kennedy 148, Jardim Oceânico - Rio de Janeiro',
    category: 'Pintura e Alvenaria',
    year: ''
  },
  {
    id: 26,
    title: 'Condomínio Cabo Frio',
    location: 'Rua Duque Estrada 86, Rio de Janeiro',
    category: 'Hidráulica',
    year: ''
  },
  {
    id: 27,
    title: 'Condomínio Miragem',
    location: 'Estrada da Água Grande 125, Irajá - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 28,
    title: 'Condomínio San Diego',
    location: 'Rua Maria Quitéria 121, Ipanema - Rio de Janeiro',
    category: 'Manutenção Predial',
    year: ''
  },
  {
    id: 29,
    title: 'Condomínio Andrea',
    location: 'Rua Almirante Sadock de Sá 225, Rio de Janeiro',
    category: 'Elétrica',
    year: ''
  },
  {
    id: 30,
    title: 'Condomínio Park Lane',
    location: 'Rua Barão de Jaguaripe 60, Ipanema - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 31,
    title: 'Condomínio Manguary',
    location: 'Rua Marquês de Abrantes 758, Flamengo - Rio de Janeiro',
    category: 'Impermeabilizações',
    year: ''
  },
  {
    id: 32,
    title: 'Condomínio Dona Aurélia',
    location: 'Av Oswaldo Cruz 76, Flamengo - Rio de Janeiro',
    category: 'Pintura e Alvenaria',
    year: ''
  },
  {
    id: 33,
    title: 'Condomínio Paulo Negrão',
    location: 'Rua Pereira da Silva 451, Laranjeiras - Rio de Janeiro',
    category: 'Reforma de Fachada',
    year: ''
  },
  {
    id: 34,
    title: 'Condomínio Chevalier',
    location: 'Rua Resada 10, Lagoa - Rio de Janeiro',
    category: 'Hidráulica',
    year: ''
  },
  {
    id: 35,
    title: 'Condomínio Taquari',
    location: 'Rua Aristide Espíndola 24, Leblon - Rio de Janeiro',
    category: 'Manutenção de Telhados',
    year: ''
  }
];

// Galeria de Trabalhos Realizados
export const workGallery = [
  {
    id: 1,
    image: '/gallery/work-1.jpg',
    title: 'Edifício Residencial',
    category: 'Reforma de Fachada'
  },
  {
    id: 2,
    image: '/gallery/work-2.jpg',
    title: 'Olhal de Ancoragem',
    category: 'Teste de Carga'
  },
  {
    id: 3,
    image: '/gallery/work-3.jpg',
    title: 'Instalação de Linha de Vida',
    category: 'Segurança'
  },
  {
    id: 4,
    image: '/gallery/work-5.jpg',
    title: 'Limpeza de Vidros',
    category: 'Manutenção Predial'
  },
  {
    id: 5,
    image: '/gallery/work-6.jpg',
    title: 'Trabalho em Altura',
    category: 'Reforma de Fachada'
  },
  {
    id: 6,
    image: '/gallery/work-7.jpg',
    title: 'Condomínio Revitalizado',
    category: 'Reforma Completa'
  },
  {
    id: 7,
    image: '/gallery/work-8.jpg',
    title: 'Teste de Percussão Pastilhas',
    category: 'Diagnóstico Técnico'
  },
  {
    id: 8,
    image: '/gallery/work-10.jpg',
    title: 'Reforma de Terraço',
    category: 'Impermeabilizações'
  },
  {
    id: 9,
    image: '/gallery/work-11.jpg',
    title: 'Reforma Prisma Ventilação',
    category: 'Manutenção Predial'
  },
  {
    id: 10,
    image: '/gallery/work-12.jpg',
    title: 'Reforma Fachada Pastilhas',
    category: 'Reforma de Fachada'
  },
  {
    id: 11,
    image: '/gallery/work-13.jpg',
    title: 'Vista Aérea Condomínio',
    category: 'Inspeção com Drone 4K'
  },
  {
    id: 12,
    image: '/gallery/work-14.jpg',
    title: 'Reforma Prisma Ventilação',
    category: 'Reforma Completa'
  }
];

export const differentials = [
  {
    id: 1,
    title: 'Equipe 100% Própria',
    description: 'Equipe técnica qualificada e 100% própria, sem terceirizados. Profissionais certificados e treinados.',
    icon: 'Users'
  },
  {
    id: 2,
    title: 'Seguro Completo',
    description: 'Seguro de obra e de vida completo em todas as obras, garantindo total segurança e tranquilidade.',
    icon: 'Shield'
  },
  {
    id: 3,
    title: 'Equipamentos de Ponta',
    description: 'Equipamentos de ponta e alta tecnologia para execução de obras com máxima eficiência e qualidade.',
    icon: 'Wrench'
  },
  {
    id: 4,
    title: 'Financiamento Próprio',
    description: 'Financiamento próprio em até 36x com a menor taxa de juros do mercado. Facilidade de pagamento.',
    icon: 'CreditCard'
  },
  {
    id: 5,
    title: 'Acompanhamento Técnico',
    description: 'Equipe técnica completa de acompanhamento: engenheiro, gestor operacional, líder técnico e mais.',
    icon: 'ClipboardList'
  },
  {
    id: 6,
    title: 'Diário de Obra Digital',
    description: 'Diário de obra moderno e digital com atualizações em tempo real de cada etapa do projeto.',
    icon: 'Smartphone'
  },
  {
    id: 7,
    title: 'Comunicação Transparente',
    description: 'Comunicação clara e transparente. Informamos o síndico sobre cada processo com didática e clareza.',
    icon: 'MessageSquare'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'Como Planejar uma Reforma de Fachada: Guia Completo para Síndicos',
    slug: 'como-planejar-reforma-fachada',
    excerpt: 'Descubra o passo a passo para planejar uma reforma de fachada eficiente, desde a análise técnica até a execução final.',
    content: `A reforma de fachada é um dos investimentos mais importantes para a valorização e conservação de um condomínio. Neste guia completo, vamos abordar todos os aspectos essenciais que síndicos e administradoras precisam conhecer.\n\n## 1. Diagnóstico Técnico Inicial\n\nAntes de qualquer decisão, é fundamental realizar uma inspeção técnica detalhada da fachada. Esta análise deve identificar:\n\n- Áreas com infiltração ou umidade\n- Trincas e fissuras estruturais\n- Deterioração de revestimentos\n- Estado de conservação das esquadrias\n- Necessidade de impermeabilização\n\n## 2. Definição de Escopo e Orçamento\n\nCom o diagnóstico em mãos, é hora de definir o escopo completo do projeto. Considere:\n\n- Serviços necessários (pintura, impermeabilização, reparos)\n- Materiais a serem utilizados\n- Cronograma de execução\n- Impacto nos moradores\n- Orçamento detalhado\n\n## 3. Aprovação em Assembleia\n\nA aprovação dos condôminos é essencial. Prepare uma apresentação clara incluindo:\n\n- Justificativa técnica da necessidade da obra\n- Comparativo de orçamentos (mínimo 3)\n- Prazo de execução\n- Forma de pagamento\n- Benefícios esperados\n\n## 4. Escolha da Empresa Qualificada\n\nA contratação da empresa certa faz toda a diferença. Verifique:\n\n- Experiência comprovada em reformas prediais\n- Regularidade fiscal e trabalhista\n- Seguro de responsabilidade civil\n- Portfólio de obras similares\n- Referências de outros condomínios\n\n## 5. Acompanhamento da Execução\n\nDurante a obra, é fundamental:\n\n- Realizar reuniões semanais de acompanhamento\n- Verificar o cumprimento do cronograma\n- Garantir a qualidade dos materiais aplicados\n- Manter os condôminos informados\n- Documentar cada etapa fotograficamente\n\n## 6. Recebimento e Garantia\n\nAo final da obra:\n\n- Faça uma vistoria técnica completa\n- Exija toda a documentação (ART, notas fiscais)\n- Verifique as garantias oferecidas\n- Solicite manual de manutenção\n\n## Conclusão\n\nUma reforma de fachada bem planejada garante não apenas a valorização do imóvel, mas também a segurança e satisfação de todos os moradores. Com planejamento adequado e uma empresa qualificada, o processo pode ser tranquilo e eficiente.\n\nA LUVCORP possui experiência comprovada em reformas de fachada, oferecendo planejamento completo e execução impecável. Entre em contato para um diagnóstico gratuito do seu condomínio.`,
    author: 'Equipe LUVCORP',
    date: '2024-03-15',
    category: 'Reforma de Fachada',
    tags: ['Reforma de Fachada', 'Planejamento', 'Gestão Condominial'],
    image: 'https://images.unsplash.com/photo-1699625809637-31c6f327ac96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxidWlsZGluZyUyMGZhY2FkZSUyMHJlbm92YXRpb258ZW58MHx8fHwxNzY5MTA2OTIzfDA&ixlib=rb-4.1.0&q=85',
    readTime: '8 min'
  },
  {
    id: 2,
    title: '5 Sinais de que sua Fachada Precisa de Reforma Urgente',
    slug: 'sinais-fachada-precisa-reforma',
    excerpt: 'Identifique os principais indicadores de que chegou a hora de investir na reforma da fachada do seu condomínio.',
    content: `A fachada é o cartão de visitas do seu condomínio. Mais do que estética, ela protege a estrutura do prédio contra intempéries e garante a segurança dos moradores. Conheça os 5 principais sinais de alerta:\n\n## 1. Manchas de Umidade e Infiltração\n\nManchas escuras, esverdeadas ou amareladas na fachada são sinais claros de infiltração. Esse problema pode:\n\n- Comprometer a estrutura do prédio\n- Causar mofo e problemas de saúde\n- Danificar apartamentos internamente\n- Desvalorizar o imóvel\n\n**Ação necessária:** Investigação imediata para identificar origem da infiltração e reparo urgente.\n\n## 2. Trincas e Fissuras\n\nNem toda trinca é motivo de pânico, mas é essencial avaliar:\n\n- **Fissuras capilares:** Menos de 0,5mm - geralmente estéticas\n- **Trincas médias:** 0,5mm a 1,5mm - requerem atenção\n- **Trincas grandes:** Acima de 1,5mm - podem indicar problema estrutural\n\n**Ação necessária:** Avaliação técnica por engenheiro estrutural para classificar gravidade e definir solução.\n\n## 3. Descolamento de Revestimento\n\nPastilhas, cerâmicas ou revestimentos soltos representam risco de queda e podem:\n\n- Causar acidentes graves\n- Indicar problema de aderência ou infiltração\n- Comprometer toda a área adjacente\n\n**Ação necessária:** Interdição da área de risco e remoção imediata das peças soltas, seguida de recuperação completa.\n\n## 4. Pintura Descascando ou Desbotada\n\nA pintura não é apenas estética - ela protege a estrutura. Sinais de deterioração incluem:\n\n- Descascamento generalizado\n- Perda significativa de cor\n- Aparecimento de manchas e bolor\n- Acúmulo de sujeira persistente\n\n**Ação necessária:** Além da repintura, investigar se há necessidade de tratamento da base e impermeabilização.\n\n## 5. Ferragem Exposta ou Oxidada\n\nFerragens aparentes são extremamente graves pois:\n\n- A oxidação expande o volume da ferragem\n- Isso causa rachaduras no concreto\n- Compromete a estrutura do edifício\n- Pode levar ao colapso parcial\n\n**Ação necessária:** Emergencial - requer intervenção estrutural imediata com engenheiro responsável.\n\n## Quando Realizar a Reforma?\n\nIdealmente, a manutenção preventiva deve ser feita a cada 5-8 anos. Porém, se algum dos sinais acima estiver presente, não espere:\n\n1. Contrate vistoria técnica profissional\n2. Obtenha laudos e orçamentos detalhados\n3. Convoque assembleia extraordinária\n4. Inicie a obra o quanto antes\n\n## Conclusão\n\nIgnorar sinais de deterioração pode resultar em custos muito maiores no futuro e, pior, colocar vidas em risco. A manutenção preventiva é sempre mais econômica que reparos emergenciais.\n\nA LUVCORP oferece serviço de vistoria técnica gratuita para identificar problemas e apresentar soluções eficientes. Entre em contato e agende uma avaliação do seu condomínio.`,
    author: 'Equipe LUVCORP',
    date: '2024-03-10',
    category: 'Manutenção Predial',
    tags: ['Manutenção', 'Segurança', 'Diagnóstico'],
    image: 'https://images.unsplash.com/photo-1763358991455-72486e02973f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxidWlsZGluZyUyMGZhY2FkZSUyMHJlbm92YXRpb258ZW58MHx8fHwxNzY5MTA2OTIzfDA&ixlib=rb-4.1.0&q=85',
    readTime: '6 min'
  },
  {
    id: 3,
    title: 'Impermeabilização de Fachadas: Tudo o que Você Precisa Saber',
    slug: 'impermeabilizacao-fachadas-guia',
    excerpt: 'Entenda a importância da impermeabilização e como ela protege seu patrimônio contra infiltrações e danos estruturais.',
    content: `A impermeabilização é uma das etapas mais críticas em qualquer projeto de reforma ou construção predial. Quando bem executada, ela garante a durabilidade e segurança da edificação. Vamos explorar tudo sobre este tema essencial.\n\n## O Que é Impermeabilização de Fachadas?\n\nA impermeabilização é o conjunto de técnicas e produtos aplicados para criar uma barreira contra a penetração de água e umidade nas estruturas. Em fachadas, ela é fundamental para:\n\n- Proteger a estrutura de concreto\n- Prevenir infiltrações nos apartamentos\n- Evitar formação de mofo e bolor\n- Aumentar a vida útil do edifício\n- Manter o valor patrimonial do imóvel\n\n## Tipos de Impermeabilização para Fachadas\n\n### 1. Impermeabilização Flexível\n\n**Produtos:** Mantas acrílicas, membranas líquidas, selantes elásticos\n\n**Vantagens:**\n- Acompanha pequenas movimentações estruturais\n- Fácil aplicação\n- Boa relação custo-benefício\n\n**Indicação:** Fachadas com movimentação térmica, regiões litorâneas\n\n### 2. Impermeabilização Rígida\n\n**Produtos:** Argamassas impermeáveis, cristalizantes\n\n**Vantagens:**\n- Alta resistência mecânica\n- Durabilidade superior\n- Proteção contra pressão hidrostática\n\n**Indicação:** Áreas com pressão de água, subsolos, embasamentos\n\n### 3. Hidrofugantes\n\n**Produtos:** Silicones, silanos, siloxanos\n\n**Vantagens:**\n- Mantém a aparência natural\n- Permite respiração da parede\n- Fácil manutenção\n\n**Indicação:** Proteção adicional sobre pinturas, acabamento final\n\n## Quando Impermeabilizar?\n\nA impermeabilização deve ser realizada:\n\n1. **Em construções novas:** Antes do acabamento final\n2. **Em reformas:** Quando houver sinais de infiltração\n3. **Preventivamente:** A cada 5-8 anos, dependendo das condições\n4. **Após reparos:** Sempre que houver intervenção na fachada\n\n## Processo Completo de Impermeabilização\n\n### Etapa 1: Diagnóstico\n- Identificação de pontos críticos\n- Análise de infiltrações existentes\n- Verificação do estado do substrato\n- Definição do sistema adequado\n\n### Etapa 2: Preparação do Substrato\n- Limpeza completa da superfície\n- Remoção de materiais soltos\n- Reparo de trincas e fissuras\n- Regularização da superfície\n- Aplicação de primer quando necessário\n\n### Etapa 3: Aplicação do Sistema\n- Aplicação do produto impermeabilizante\n- Respeito aos tempos de cura\n- Número adequado de demãos\n- Atenção especial aos pontos críticos\n\n### Etapa 4: Acabamento e Proteção\n- Aplicação de revestimento final\n- Pintura com produtos adequados\n- Proteção mecânica quando necessária\n\n### Etapa 5: Teste e Garantia\n- Teste de estanqueidade\n- Inspeção final\n- Documentação técnica\n- Emissão de garantia\n\n## Erros Comuns a Evitar\n\n❌ **Aplicar impermeabilizante sobre superfície úmida**\nResultado: Falta de aderência e falha do sistema\n\n❌ **Não preparar adequadamente o substrato**\nResultado: Descascamento e perda de eficiência\n\n❌ **Usar produto inadequado para o tipo de superfície**\nResultado: Impermeabilização ineficaz\n\n❌ **Economizar em número de demãos**\nResultado: Proteção insuficiente\n\n❌ **Não respeitar tempos de cura**\nResultado: Comprometimento do sistema\n\n## Manutenção da Impermeabilização\n\nPara garantir a eficácia duradoura:\n\n- Realize inspeções visuais semestrais\n- Limpe periodicamente a fachada\n- Repare pequenos danos imediatamente\n- Reaplique hidrofugante a cada 2-3 anos\n- Mantenha registros de todas as intervenções\n\n## Custo-Benefício\n\nMuitos síndicos hesitam devido ao investimento inicial, mas considere:\n\n- Custo de impermeabilização: R$ 80-150/m²\n- Custo de reparo de infiltração: R$ 300-800/m²\n- Prejuízos indiretos (móveis, pinturas internas): Incalculável\n\n**Investir em impermeabilização de qualidade é sempre mais econômico que reparar danos.**\n\n## Conclusão\n\nA impermeabilização é um investimento essencial na proteção do patrimônio. Quando bem executada por profissionais qualificados e com materiais de qualidade, ela garante tranquilidade por muitos anos.\n\nA LUVCORP é especialista em sistemas de impermeabilização de fachadas, utilizando as melhores técnicas e produtos do mercado. Oferecemos garantia estendida e acompanhamento técnico pós-obra.\n\n**Solicite um orçamento sem compromisso e proteja seu patrimônio.**`,
    author: 'Eng. Carlos Silva',
    date: '2024-03-05',
    category: 'Impermeabilização',
    tags: ['Impermeabilização', 'Técnicas', 'Prevenção'],
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzY5MTA2OTMxfDA&ixlib=rb-4.1.0&q=85',
    readTime: '10 min'
  },
  {
    id: 4,
    title: 'Normas de Segurança em Obras de Fachada: O Que Exigir da Empresa Contratada',
    slug: 'normas-seguranca-obras-fachada',
    excerpt: 'Conheça as principais normas de segurança que devem ser seguidas em obras de reforma de fachada e como fiscalizar.',
    content: `A segurança em obras de fachada não é opcional - é obrigação legal e moral. Como síndico ou gestor condominial, você precisa conhecer as normas e exigir seu cumprimento integral. Vidas dependem disso.\n\n## Principais Normas Regulamentadoras\n\n### NR-18: Condições e Meio Ambiente de Trabalho na Indústria da Construção\n\nÉ a norma mais importante para obras de fachada. Ela estabelece:\n\n**Requisitos obrigatórios:**\n- PCMAT (Programa de Condições e Meio Ambiente de Trabalho)\n- Sistemas de proteção contra quedas\n- Isolamento da área de trabalho\n- Sinalização adequada\n- Equipamentos de proteção coletiva (EPC)\n- Equipamentos de proteção individual (EPI)\n\n### NR-35: Trabalho em Altura\n\nAplica-se a todas as atividades acima de 2 metros do piso. Exige:\n\n**Obrigações da empresa:**\n- Análise de risco específica\n- Planejamento das atividades\n- Capacitação de trabalhadores\n- Sistema de permissão de trabalho\n- Supervisão técnica permanente\n\n**Obrigações dos trabalhadores:**\n- Treinamento específico (mínimo 8 horas)\n- Reciclagem bienal\n- Exames médicos específicos\n- Uso correto de EPIs\n\n## Equipamentos de Proteção Obrigatórios\n\n### Proteção Coletiva (EPC)\n\n1. **Andaimes Fachadeiros**\n   - Montagem por profissional qualificado\n   - Inspeção diária obrigatória\n   - Carga máxima respeitada\n   - Telas de proteção instaladas\n\n2. **Bandejas de Proteção**\n   - Instaladas a cada 3 metros de altura\n   - Projeção mínima de 2,5 metros\n   - Capazes de suportar impactos\n\n3. **Telas de Proteção**\n   - Tipo helanca ou similar\n   - Envolvimento total da área de trabalho\n   - Fixação adequada e resistente\n\n4. **Guarda-Corpos e Rodapés**\n   - Altura mínima de 1,20m\n   - Travessas intermediárias\n   - Rodapé de 20cm\n\n### Proteção Individual (EPI)\n\n✓ Capacete com jugular\n✓ Óculos de proteção\n✓ Cinto de segurança tipo paraquedista\n✓ Trava-quedas\n✓ Linha de vida\n✓ Luvas de proteção\n✓ Calçado de segurança\n✓ Máscara contra poeira\n\n## Sistema de Isolamento e Sinalização\n\nA área embaixo da obra deve ser SEMPRE isolada:\n\n**Perímetro de segurança:**\n- Distância mínima: 1,5x a altura da edificação\n- Tapumes resistentes e sinalizados\n- Controle de acesso de pedestres\n- Sinalização luminosa noturna\n- Vigia quando necessário\n\n**Sinalização obrigatória:**\n- Placas de "Área de risco"\n- Identificação da obra e responsável técnico\n- Telefones de emergência\n- Sinalização de rotas alternativas\n\n## Responsabilidades Legais\n\n### Da Empresa Contratada\n- Elaborar e implementar PCMAT\n- Fornecer todos os EPIs e EPCs\n- Treinar e capacitar trabalhadores\n- Manter profissional de segurança\n- Realizar DDS (Diálogo Diário de Segurança)\n- Manter ART ativa durante toda a obra\n\n### Do Condomínio/Síndico\n- Exigir documentação de segurança\n- Fiscalizar cumprimento das normas\n- Não permitir trabalho irregular\n- Garantir acesso para fiscalização\n- Manter registros de vistorias\n\n### Dos Trabalhadores\n- Usar corretamente os EPIs\n- Participar dos treinamentos\n- Reportar situações de risco\n- Seguir procedimentos estabelecidos\n- Zelar pela própria segurança e dos colegas\n\n## Checklist de Segurança para Síndicos\n\nAntes de autorizar início da obra, verifique:\n\n□ PCMAT aprovado e disponível na obra\n□ ART (Anotação de Responsabilidade Técnica) ativa\n□ Profissional de segurança designado\n□ ASO (Atestado de Saúde Ocupacional) dos trabalhadores\n□ Certificados de treinamento NR-35\n□ Seguro de responsabilidade civil vigente\n□ Projeto de andaimes aprovado\n□ EPIs e EPCs disponíveis e adequados\n□ Isolamento da área implementado\n□ Sinalização instalada\n□ Plano de emergência definido\n□ Telefones de emergência visíveis\n\nDurante a obra, verifique semanalmente:\n\n□ Uso correto de EPIs por todos\n□ Estado de conservação dos andaimes\n□ Integridade das telas e proteções\n□ Organização e limpeza da obra\n□ Realização de DDS diário\n□ Livro de ocorrências atualizado\n□ Descarte adequado de resíduos\n\n## Penalidades pelo Descumprimento\n\n**Para as empresas:**\n- Multas do Ministério do Trabalho\n- Embargo da obra\n- Cassação de alvarás\n- Responsabilização civil e criminal\n- Ações trabalhistas\n\n**Para o condomínio:**\n- Responsabilidade solidária\n- Ações de indenização\n- Desvalorização do imóvel\n- Impacto na imagem\n\n## Acidentes Mais Comuns e Como Prevenir\n\n### 1. Quedas de Altura\n**Prevenção:**\n- Cinto de segurança sempre\n- Linha de vida adequada\n- Guarda-corpos em todo perímetro\n- Supervisão constante\n\n### 2. Queda de Materiais\n**Prevenção:**\n- Bandejas de proteção\n- Elevadores de carga adequados\n- Proibição de lançamento de materiais\n- Isolamento efetivo da área\n\n### 3. Acidentes com Equipamentos\n**Prevenção:**\n- Manutenção preventiva rigorosa\n- Operação apenas por habilitados\n- Inspeção diária\n- Procedimentos operacionais claros\n\n## Conclusão\n\nA segurança em obras de fachada é inegociável. Como síndico, você tem o poder e o dever de exigir que todas as normas sejam cumpridas. Não aceite desculpas ou atalhos - vidas estão em jogo.\n\nUma empresa séria e profissional não apenas aceita essas exigências, mas as pratica naturalmente como parte de sua cultura organizacional.\n\n**A LUVCORP coloca a segurança em primeiro lugar.** Todas as nossas obras seguem rigorosamente as normas NR-18 e NR-35, com profissionais treinados, equipamentos certificados e supervisão técnica permanente. Fornecemos toda a documentação necessária e mantemos os síndicos informados sobre todos os aspectos de segurança.\n\n**Solicite uma apresentação de nossos protocolos de segurança. Sua tranquilidade é nossa prioridade.**`,
    author: 'Téc. Seg. João Santos',
    date: '2024-02-28',
    category: 'Segurança',
    tags: ['Segurança', 'Normas', 'Fiscalização'],
    image: 'https://images.pexels.com/photos/1216544/pexels-photo-1216544.jpeg',
    readTime: '12 min'
  },
  {
    id: 5,
    title: 'Teste de Percussão em Fachadas: Por Que Ele Evita Acidentes e Gastos Inesperados',
    slug: 'teste-de-percussao-fachadas-evita-acidentes',
    excerpt: 'Entenda como o teste de percussão identifica riscos ocultos antes da reforma e evita custos inesperados durante a execução da obra.',
    content: `O teste de percussão é uma técnica simples, rápida e extremamente eficaz para diagnosticar problemas ocultos em fachadas antes do início de qualquer reforma.\n\n## O Que é o Teste de Percussão?\n\nO teste consiste em percutir (bater levemente) a superfície da fachada com um martelo de borracha ou instrumento similar. O som produzido revela a condição do revestimento:\n\n- **Som sólido/compacto**: Revestimento bem aderido\n- **Som cavo/oco**: Possível descolamento do reboco ou revestimento\n\n## Por Que o Teste é Essencial?\n\n### 1. Identificação Prévia de Riscos\n\nO teste permite localizar áreas comprometidas antes do início da obra, evitando surpresas durante a execução.\n\n### 2. Prevenção de Acidentes\n\nRevestimentos soltos representam risco de queda e acidentes graves. O teste identifica essas áreas críticas.\n\n### 3. Definição Correta do Escopo\n\nCom o diagnóstico completo, o orçamento reflete a realidade da fachada, evitando custos adicionais inesperados.\n\n### 4. Planejamento Adequado\n\nPermite dimensionar corretamente materiais, mão de obra e prazo de execução.\n\n## Como é Realizado?\n\n1. **Inspeção Visual**: Identificação de áreas suspeitas\n2. **Teste de Percussão**: Batidas sistemáticas em toda a fachada\n3. **Marcação**: Áreas com som cavo são marcadas\n4. **Relatório Técnico**: Documento com localização e extensão dos problemas\n5. **Registro Fotográfico**: Evidências para orçamento e assembleia\n\n## Quando Realizar?\n\n- Antes de qualquer reforma de fachada\n- Em edifícios com mais de 10 anos\n- Quando há suspeita de infiltração\n- Após eventos climáticos extremos\n- Como manutenção preventiva periódica\n\n## Benefícios para o Condomínio\n\n✓ **Segurança**: Previne acidentes com pedestres e moradores\n✓ **Economia**: Evita custos extras durante a obra\n✓ **Planejamento**: Orçamento realista desde o início\n✓ **Transparência**: Informações claras para assembleia\n✓ **Conformidade**: Atende normas técnicas e boas práticas\n\n## A LUVCORP e o Teste de Percussão\n\nA LUVCORP realiza o teste de percussão como etapa obrigatória antes de qualquer proposta de reforma de fachada. Nossos técnicos são treinados para identificar com precisão áreas comprometidas e fornecer relatórios detalhados.\n\n**Solicite uma vistoria técnica gratuita e garanta a segurança do seu condomínio.**`,
    author: 'Equipe Técnica LUVCORP',
    date: '2025-01-20',
    category: 'Diagnóstico Técnico',
    tags: ['Teste de Percussão', 'Segurança', 'Prevenção'],
    image: '/gallery/work-8.jpg',
    readTime: '7 min'
  },
  {
    id: 6,
    title: 'Inspeção Predial com Drone: Quando Usar e Quais São os Benefícios',
    slug: 'inspecao-predial-drone-beneficios',
    excerpt: 'Descubra como a tecnologia de drone 4K revoluciona inspeções de fachadas, reduzindo custos, riscos e tempo de execução.',
    content: `A tecnologia de drones transformou a forma como realizamos inspeções prediais, especialmente em fachadas altas e áreas de difícil acesso.\n\n## O Que é Inspeção com Drone?\n\nÉ o uso de veículos aéreos não tripulados (drones) equipados com câmeras de alta resolução para inspecionar fachadas, coberturas e áreas externas de edifícios.\n\n## Quando Usar Drone na Inspeção?\n\n### Situações Ideais:\n\n- **Edifícios altos**: Acima de 10 andares\n- **Áreas de difícil acesso**: Marquises, coberturas, torres\n- **Inspeções preliminares**: Antes de reforma ou manutenção\n- **Diagnóstico rápido**: Identificação de problemas urgentes\n- **Documentação**: Registro antes e depois de obras\n\n## Benefícios da Inspeção com Drone\n\n### 1. Segurança Total\n\n- Elimina necessidade de andaimes em inspeções preliminares\n- Reduz exposição de trabalhadores a riscos\n- Não interfere na rotina dos moradores\n\n### 2. Redução de Custos\n\n- Dispensa montagem de andaimes para diagnóstico\n- Inspeção mais rápida = menor custo\n- Identificação precisa de problemas antes do orçamento\n\n### 3. Qualidade Superior\n\n- Câmeras 4K capturam detalhes invisíveis a olho nu\n- Zoom permite análise minuciosa de fissuras e problemas\n- Imagens e vídeos em alta resolução\n\n### 4. Agilidade\n\n- Inspeção completa em poucas horas\n- Relatório técnico rápido\n- Tomada de decisão mais ágil\n\n### 5. Documentação Completa\n\n- Registro visual detalhado\n- Material para apresentação em assembleia\n- Evidências para laudos técnicos\n\n## Conformidade Legal\n\nA LUVCORP opera em total conformidade com:\n\n- **ANAC**: Drone registrado\n- **DECEA**: Autorização para voos\n- **ANATEL**: Equipamentos homologados\n- **Operadores habilitados**: Pilotos certificados\n\n## Limitações do Drone\n\nÉ importante entender que o drone:\n\n- **Não substitui** inspeção tátil (teste de percussão)\n- **Não substitui** laudo estrutural detalhado\n- É uma **ferramenta complementar** valiosa\n\n## Tecnologia LUVCORP\n\nA LUVCORP utiliza drones de última geração com:\n\n- Câmeras 4K com estabilização\n- Voo autônomo programado\n- Sensores de segurança\n- Operadores certificados\n\n## Resultado Final\n\nInspeção moderna, segura e econômica que fornece informações precisas para tomada de decisão sobre reformas e manutenções.\n\n**Solicite uma inspeção com drone e conheça o real estado da fachada do seu condomínio.**`,
    author: 'Equipe Técnica LUVCORP',
    date: '2025-01-18',
    category: 'Tecnologia',
    tags: ['Drone', 'Inspeção', 'Tecnologia'],
    image: '/gallery/work-13.jpg',
    readTime: '8 min'
  },
  {
    id: 7,
    title: 'Por Que a Tinta Emborrachada é a Melhor Escolha para Fachadas Prediais',
    slug: 'tinta-emborrachada-melhor-escolha-fachadas',
    excerpt: 'Entenda as vantagens técnicas da tinta emborrachada e por que ela oferece melhor custo-benefício a longo prazo.',
    content: `A escolha da tinta é uma das decisões mais importantes em uma reforma de fachada. Entenda por que a LUVCORP trabalha exclusivamente com tinta emborrachada.\n\n## Tinta Acrílica Comum vs Tinta Emborrachada\n\n### Tinta Acrílica Comum\n\n- Menor elasticidade\n- Fissuras aparecem mais rápido\n- Impermeabilização limitada\n- Vida útil: 2-3 anos\n\n### Tinta Emborrachada\n\n- Alta elasticidade\n- Acompanha movimentações da estrutura\n- Excelente impermeabilização\n- Vida útil: 5-7 anos\n\n## Benefícios da Tinta Emborrachada\n\n### 1. Elasticidade Superior\n\nA tinta emborrachada pode esticar até 300% sem rachar, acompanhando as pequenas movimentações naturais da estrutura causadas por:\n\n- Variação térmica\n- Acomodação da estrutura\n- Vibrações urbanas\n\n### 2. Impermeabilização Eficaz\n\nCria uma camada flexível e impermeável que:\n\n- Bloqueia penetração de água\n- Previne infiltrações\n- Protege a estrutura\n- Reduz formação de mofo\n\n### 3. Durabilidade Estendida\n\n- Resiste melhor ao sol e chuva\n- Mantém cor por mais tempo\n- Menor desgaste por intempéries\n- Necessita repintura menos frequente\n\n### 4. Redução de Fissuras Aparentes\n\nGraças à elasticidade:\n\n- Microfissuras não aparecem\n- Fachada sempre com aspecto novo\n- Menor necessidade de manutenção\n\n### 5. Melhor Custo-Benefício\n\nApesar do custo inicial superior:\n\n- Dura 2x mais que tinta comum\n- Menos manutenções\n- Menor custo total ao longo dos anos\n\n## Aplicação Profissional\n\nA aplicação correta é essencial:\n\n1. **Preparo de superfície**: Limpeza e tratamento\n2. **Massa acrílica**: Correção de imperfeições\n3. **Primer**: Selador de base\n4. **Tinta emborrachada**: 2-3 demãos\n5. **Cura adequada**: Respeito ao tempo entre demãos\n\n## Quando Usar Tinta Emborrachada\n\n✓ Fachadas com histórico de fissuras\n✓ Edifícios expostos ao sol intenso\n✓ Regiões com alta pluviosidade\n✓ Quando se busca durabilidade\n✓ Em qualquer reforma de fachada que priorize qualidade\n\n## Padrão LUVCORP\n\nA LUVCORP utiliza exclusivamente tinta emborrachada de primeira linha porque:\n\n- Prezamos pela durabilidade\n- Garantimos qualidade superior\n- Reduzimos necessidade de manutenção\n- Entregamos valor real ao condomínio\n\n## Marcas Utilizadas\n\nTrabalhamos com:\n\n- Suvinil Elastec\n- Coral Alta Resistência\n- Sherwin-Williams ProElastic\n\n**Invista em qualidade que dura. Solicite um orçamento com tinta emborrachada.**`,
    author: 'Eng. Matheus de Souza',
    date: '2025-01-15',
    category: 'Materiais',
    tags: ['Tinta Emborrachada', 'Qualidade', 'Durabilidade'],
    image: '/gallery/work-7.jpg',
    readTime: '6 min'
  },
  {
    id: 8,
    title: 'Quanto Tempo Dura uma Reforma de Fachada? Entenda o Cronograma Real',
    slug: 'quanto-tempo-dura-reforma-fachada-cronograma',
    excerpt: 'Saiba quanto tempo realmente leva uma reforma de fachada e quais fatores influenciam o prazo de execução.',
    content: `Uma das primeiras perguntas de síndicos ao planejar uma reforma de fachada é: "Quanto tempo vai durar?". A resposta depende de diversos fatores.\n\n## Fatores que Influenciam o Prazo\n\n### 1. Tamanho da Fachada\n\n- **Até 500m²**: 30-60 dias\n- **500m² a 1.500m²**: 60-120 dias\n- **Acima de 1.500m²**: 120-180 dias\n\n### 2. Escopo dos Serviços\n\nServiços incluídos na reforma:\n\n- Apenas pintura: +30 dias\n- Tratamento de fissuras: +15-30 dias\n- Impermeabilização: +15-30 dias\n- Reparos estruturais: +30-60 dias\n- Troca de revestimento: +60-90 dias\n\n### 3. Condições Climáticas\n\nO clima afeta diretamente o cronograma:\n\n- **Chuvas**: Paralisam trabalhos externos\n- **Umidade alta**: Impede aplicação de tintas\n- **Vento forte**: Risco para trabalho em altura\n\n### 4. Acesso e Logística\n\n- Ruas estreitas dificultam montagem de andaimes\n- Falta de espaço para materiais\n- Restrições de horário em áreas comerciais\n\n## Cronograma Típico\n\n### Fase 1: Preparação (5-10 dias)\n- Montagem de andaimes\n- Instalação de proteções\n- Isolamento de áreas\n\n### Fase 2: Diagnóstico e Reparos (15-30 dias)\n- Teste de percussão\n- Remoção de partes soltas\n- Tratamento de fissuras\n- Reparos estruturais\n\n### Fase 3: Impermeabilização (10-20 dias)\n- Aplicação de impermeabilizante\n- Tempo de cura\n- Testes de estanqueidade\n\n### Fase 4: Acabamento (20-40 dias)\n- Aplicação de massa\n- Pintura (múltiplas demãos)\n- Tempo de secagem entre demãos\n\n### Fase 5: Finalização (5-10 dias)\n- Desmontagem de andaimes\n- Limpeza geral\n- Vistoria final\n\n## Como a LUVCORP Trabalha\n\nNa LUVCORP:\n\n- Cronograma detalhado antes do início\n- Atualizações semanais sobre progresso\n- Plano de contingência para chuvas\n- Equipe dimensionada para o prazo\n- Diário de obra digital em tempo real\n\n**Solicite um orçamento com cronograma personalizado para sua fachada.**`,
    author: 'Equipe LUVCORP',
    date: '2025-01-12',
    category: 'Planejamento',
    tags: ['Cronograma', 'Planejamento', 'Gestão de Obra'],
    image: '/gallery/work-6.jpg',
    readTime: '7 min'
  },
  {
    id: 9,
    title: 'O Papel do Síndico na Reforma de Fachada: Responsabilidades e Boas Práticas',
    slug: 'papel-sindico-reforma-fachada-responsabilidades',
    excerpt: 'Guia completo sobre as responsabilidades do síndico durante uma reforma de fachada e como garantir uma obra bem-sucedida.',
    content: `O síndico desempenha papel fundamental no sucesso de uma reforma de fachada. Conheça suas responsabilidades e boas práticas.\n\n## Responsabilidades Legais do Síndico\n\n### Antes da Obra\n\n1. **Convocar Assembleia**: A reforma de fachada exige aprovação em assembleia (quórum conforme convenção)\n2. **Obter Orçamentos**: Mínimo de 3 orçamentos detalhados\n3. **Verificar Documentação**: ART, CREA, seguros\n4. **Analisar Contrato**: Cláusulas de prazo, garantia, pagamento\n5. **Comunicar Moradores**: Informar sobre a obra e impactos\n\n### Durante a Obra\n\n1. **Fiscalizar Execução**: Verificar cumprimento do contrato\n2. **Exigir Segurança**: Garantir uso de EPIs e EPCs\n3. **Controlar Pagamentos**: Liberar conforme cronograma\n4. **Documentar Tudo**: Registrar evolução e ocorrências\n5. **Mediar Conflitos**: Resolver problemas entre empresa e moradores\n\n### Após a Obra\n\n1. **Realizar Vistoria**: Verificar execução completa\n2. **Obter Documentos**: ART de conclusão, garantias\n3. **Prestar Contas**: Apresentar relatório em assembleia\n4. **Arquivar Documentação**: Guardar para futuras referências\n\n## Boas Práticas\n\n### Comunicação Eficiente\n\n- Informe moradores antes do início\n- Atualize semanalmente sobre progresso\n- Disponibilize canal para dúvidas\n- Comunique imprevistos imediatamente\n\n### Fiscalização Ativa\n\n- Visite a obra regularmente\n- Verifique qualidade dos materiais\n- Confira uso de equipamentos de segurança\n- Compare execução com projeto\n\n### Gestão Financeira\n\n- Crie fundo específico para obra\n- Vincule pagamentos a entregas\n- Mantenha reserva para imprevistos\n- Documente todos os pagamentos\n\n### Documentação Completa\n\n- Fotografe antes, durante e depois\n- Registre todas as reuniões\n- Arquive notas fiscais e recibos\n- Guarde comunicações por escrito\n\n## Erros Comuns a Evitar\n\n❌ Contratar sem assembleia\n❌ Escolher pelo menor preço\n❌ Não verificar documentação\n❌ Pagar adiantado\n❌ Não fiscalizar a obra\n❌ Aceitar alterações verbais\n\n## Como a LUVCORP Apoia o Síndico\n\nA LUVCORP oferece suporte completo:\n\n- Apresentação detalhada para assembleia\n- Toda documentação organizada\n- Relatórios periódicos de acompanhamento\n- Diário de obra digital\n- Canal direto com gestor da obra\n\n**Conte com a LUVCORP para uma reforma tranquila e bem-sucedida.**`,
    author: 'Equipe LUVCORP',
    date: '2025-01-10',
    category: 'Gestão Condominial',
    tags: ['Síndico', 'Responsabilidades', 'Boas Práticas'],
    image: '/gallery/work-1.jpg',
    readTime: '9 min'
  },
  {
    id: 10,
    title: 'Impermeabilização de Laje: Proteção Essencial para seu Condomínio',
    slug: 'impermeabilizacao-laje-protecao-condominio',
    excerpt: 'Entenda a importância da impermeabilização de lajes e como ela previne infiltrações e danos estruturais.',
    content: `A impermeabilização de lajes é uma das proteções mais importantes para a saúde estrutural do edifício.\n\n## Por Que Impermeabilizar Lajes?\n\n### Proteção Contra Infiltrações\n\nLajes expostas recebem:\n\n- Chuva direta\n- Radiação solar intensa\n- Variações térmicas extremas\n\nSem impermeabilização, a água penetra e causa:\n\n- Manchas no teto dos apartamentos\n- Mofo e bolor\n- Corrosão das ferragens\n- Danos estruturais\n\n### Tipos de Laje que Necessitam Impermeabilização\n\n- **Laje de cobertura**: Exposição total\n- **Terraços**: Áreas descobertas\n- **Área de máquinas**: Vibrações e intempéries\n- **Garagens descobertas**: Tráfego + exposição\n- **Floreiras**: Umidade constante\n\n## Sistemas de Impermeabilização\n\n### 1. Manta Asfáltica\n\n**Características:**\n- Alta durabilidade (10-15 anos)\n- Resistência a punção\n- Aplicação por maçarico\n\n**Indicação:** Lajes com tráfego, áreas técnicas\n\n### 2. Membrana Líquida\n\n**Características:**\n- Aplicação por pintura\n- Flexibilidade\n- Sem emendas\n\n**Indicação:** Lajes com detalhes, pequenas áreas\n\n### 3. Manta Aluminizada\n\n**Características:**\n- Refletividade térmica\n- Proteção UV\n- Redução de temperatura\n\n**Indicação:** Coberturas expostas ao sol\n\n## Processo de Impermeabilização\n\n### Etapa 1: Inspeção\n- Verificação do estado da laje\n- Identificação de problemas existentes\n- Definição do sistema adequado\n\n### Etapa 2: Preparo\n- Limpeza completa\n- Remoção de impermeabilização antiga\n- Reparo de trincas e fissuras\n- Regularização da superfície\n\n### Etapa 3: Aplicação\n- Primer de aderência\n- Aplicação do sistema impermeabilizante\n- Tratamento de pontos críticos\n- Proteção mecânica\n\n### Etapa 4: Teste\n- Teste de estanqueidade\n- Verificação de caimento\n- Documentação fotográfica\n\n## Sinais de Necessidade de Impermeabilização\n\n⚠️ Manchas no teto dos últimos andares\n⚠️ Goteiras em dias de chuva\n⚠️ Umidade nas paredes superiores\n⚠️ Manta antiga deteriorada\n⚠️ Bolhas ou descolamentos visíveis\n\n## Manutenção Preventiva\n\nPara prolongar a vida útil:\n\n- Inspeção anual obrigatória\n- Limpeza de ralos e calhas\n- Verificação de juntas de dilatação\n- Reparo imediato de pequenos danos\n\n**A LUVCORP é especialista em impermeabilização de lajes. Solicite uma vistoria gratuita.**`,
    author: 'Eng. Matheus de Souza',
    date: '2025-01-08',
    category: 'Impermeabilização',
    tags: ['Impermeabilização', 'Laje', 'Manutenção Preventiva'],
    image: '/gallery/work-10.jpg',
    readTime: '8 min'
  },
  {
    id: 11,
    title: 'Linha de Vida em Edifícios: Segurança Obrigatória para Manutenção de Fachadas',
    slug: 'linha-vida-edificios-seguranca-manutencao-fachadas',
    excerpt: 'Saiba por que a linha de vida é essencial para a segurança em trabalhos de manutenção e como garantir conformidade legal.',
    content: `A linha de vida é um sistema de segurança obrigatório para edifícios que necessitam de manutenção em fachadas e coberturas.\n\n## O Que é Linha de Vida?\n\nÉ um sistema de ancoragem permanente instalado em edifícios para permitir que trabalhadores realizem serviços em altura com segurança. Composta por:\n\n- **Pontos de ancoragem**: Fixados na estrutura\n- **Cabo de aço ou trilho**: Conecta os pontos\n- **Conectores**: Onde o trabalhador se prende\n\n## Por Que é Obrigatória?\n\n### Legislação\n\nA NR-35 (Trabalho em Altura) exige:\n\n- Sistema de ancoragem em edificações\n- Projeto por profissional habilitado\n- ART de instalação\n- Inspeção periódica\n- Teste de carga anual\n\n### Responsabilidade\n\nO condomínio que não possui linha de vida:\n\n- Não pode contratar serviços de fachada\n- Assume responsabilidade em acidentes\n- Pode ser multado pelo Ministério do Trabalho\n- Pode responder criminalmente\n\n## Tipos de Linha de Vida\n\n### 1. Cabo de Aço\n\n**Características:**\n- Instalação horizontal ou vertical\n- Permite movimentação livre\n- Custo mais acessível\n\n**Indicação:** Fachadas planas, coberturas\n\n### 2. Trilho\n\n**Características:**\n- Movimentação mais fluida\n- Maior durabilidade\n- Estética mais discreta\n\n**Indicação:** Edifícios de alto padrão\n\n### 3. Ponto Fixo\n\n**Características:**\n- Ancoragem pontual\n- Para áreas específicas\n- Complementar ao cabo\n\n**Indicação:** Áreas técnicas, marquises\n\n## Instalação Profissional\n\n### Etapas\n\n1. **Projeto**: Engenheiro calcula carga e posicionamento\n2. **Instalação**: Por empresa especializada\n3. **Teste de Carga**: Verificação da resistência\n4. **ART**: Documento de responsabilidade técnica\n5. **Treinamento**: Para equipe de manutenção\n\n### Requisitos\n\n- Resistência mínima: 1.500 kgf por ponto\n- Espaçamento máximo: 12 metros entre pontos\n- Material: Aço inoxidável ou galvanizado\n- Altura: Mínimo 1,10m do piso\n\n## Manutenção Obrigatória\n\n### Inspeção Visual (Semestral)\n- Verificar corrosão\n- Checar fixações\n- Avaliar estado geral\n\n### Teste de Carga (Anual)\n- Por empresa certificada\n- Com laudo técnico\n- Renovação de ART\n\n## Benefícios para o Condomínio\n\n✓ **Conformidade Legal**: Atende NR-35\n✓ **Segurança**: Protege trabalhadores\n✓ **Economia**: Facilita manutenções\n✓ **Valorização**: Diferencial para o imóvel\n✓ **Tranquilidade**: Síndico protegido legalmente\n\n## A LUVCORP e Linhas de Vida\n\nA LUVCORP oferece:\n\n- Projeto por engenheiro especializado\n- Instalação com materiais certificados\n- Teste de carga e documentação\n- Manutenção preventiva\n\n**Regularize seu edifício. Solicite um orçamento para linha de vida.**`,
    author: 'Equipe Técnica LUVCORP',
    date: '2025-01-05',
    category: 'Segurança',
    tags: ['Linha de Vida', 'NR-35', 'Segurança do Trabalho'],
    image: '/gallery/work-3.jpg',
    readTime: '9 min'
  },
  {
    id: 12,
    title: 'Como Aprovar uma Reforma de Fachada em Assembleia: Guia Prático para Síndicos',
    slug: 'como-aprovar-reforma-fachada-assembleia-guia',
    excerpt: 'Passo a passo para preparar e conduzir uma assembleia que aprove a reforma de fachada com sucesso.',
    content: `Aprovar uma reforma de fachada em assembleia pode ser desafiador. Este guia apresenta estratégias para aumentar suas chances de sucesso.\n\n## Preparação Antes da Assembleia\n\n### 1. Documente a Necessidade\n\nReúna evidências concretas:\n\n- Laudo técnico de engenheiro\n- Fotos dos problemas\n- Histórico de infiltrações\n- Reclamações de moradores\n- Laudos de vistorias anteriores\n\n### 2. Obtenha Orçamentos\n\nRegras essenciais:\n\n- Mínimo 3 orçamentos\n- Escopo idêntico para comparação\n- Detalhamento de serviços\n- Cronograma físico-financeiro\n- Verificação de credenciais\n\n### 3. Prepare Apresentação\n\nInclua obrigatoriamente:\n\n- Diagnóstico técnico\n- Riscos de não fazer a obra\n- Comparativo de propostas\n- Formas de pagamento\n- Impacto no condomínio\n- Benefícios esperados\n\n### 4. Defina Estratégia de Pagamento\n\nOpções comuns:\n\n- **Taxa extra**: Valor mensal adicional\n- **Fundo de reserva**: Se houver saldo\n- **Financiamento**: Parcelas fixas\n- **Rateio único**: Para obras menores\n\n## Convocação da Assembleia\n\n### Requisitos Legais\n\n- Antecedência mínima conforme convenção (geralmente 10 dias)\n- Pauta clara e específica\n- Envio a todos os condôminos\n- Disponibilização de documentos para consulta\n\n### Pauta Sugerida\n\n1. Apresentação do diagnóstico técnico\n2. Exposição dos orçamentos\n3. Discussão das propostas\n4. Definição de forma de pagamento\n5. Votação\n\n## Condução da Assembleia\n\n### Estratégias de Sucesso\n\n**Seja objetivo:**\n- Apresentação clara e concisa\n- Foco nos fatos, não opiniões\n- Dados e evidências\n\n**Antecipe objeções:**\n- "É muito caro" → Mostre custo de não fazer\n- "Pode esperar" → Apresente riscos\n- "Tem empresa mais barata" → Compare escopo\n\n**Facilite participação:**\n- Reserve tempo para perguntas\n- Ouça todas as opiniões\n- Mantenha o respeito\n\n### Quórum Necessário\n\nConsulte sua convenção. Geralmente:\n\n- **Obra necessária**: Maioria simples\n- **Obra voluptuária**: 2/3 ou maioria qualificada\n- **Alteração de fachada**: Unanimidade\n\n## Após a Aprovação\n\n### Formalize Tudo\n\n- Ata assinada por todos presentes\n- Registro em cartório se necessário\n- Comunicação a todos os moradores\n- Contrato com empresa escolhida\n\n### Implemente com Transparência\n\n- Comunique início da obra\n- Atualize sobre progresso\n- Preste contas regularmente\n- Documente cada etapa\n\n## Dicas Extras\n\n✓ **Convide a empresa** para apresentar na assembleia\n✓ **Disponibilize materiais** com antecedência\n✓ **Prepare FAQ** com perguntas frequentes\n✓ **Tenha apoio** de moradores influentes\n✓ **Seja transparente** sobre custos e prazos\n\n## Como a LUVCORP Ajuda\n\nA LUVCORP apoia síndicos em assembleias:\n\n- Apresentação profissional do projeto\n- Material visual de qualidade\n- Respostas técnicas às dúvidas\n- Proposta clara e detalhada\n- Flexibilidade de pagamento\n\n**Conte com a LUVCORP para aprovar e executar sua reforma com sucesso.**`,
    author: 'Equipe LUVCORP',
    date: '2025-01-02',
    category: 'Gestão Condominial',
    tags: ['Assembleia', 'Aprovação', 'Síndico'],
    image: '/gallery/work-12.jpg',
    readTime: '10 min'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Jorge Antônio',
    role: 'Síndico - Múltiplos Condomínios',
    content: 'A LUVCORP superou nossas expectativas. A obra foi entregue no prazo, com qualidade impecável e total transparência em todas as etapas.',
    rating: 5,
    project: 'Reforma de Fachada'
  },
  {
    id: 2,
    name: 'Marcio Barbalat',
    role: 'Síndico - Múltiplos Condomínios',
    content: 'Trabalho com a LUVCORP há anos. Profissionalismo, pontualidade e qualidade técnica em todos os projetos. Empresa de confiança.',
    rating: 5,
    project: 'Múltiplas Obras'
  },
  {
    id: 3,
    name: 'Giseli Soares',
    role: 'Síndica - Múltiplos Condomínios',
    content: 'Equipe extremamente qualificada e atenciosa. Resolveram problemas complexos de infiltração que outras empresas não conseguiram.',
    rating: 5,
    project: 'Impermeabilização'
  },
  {
    id: 4,
    name: 'Leandro Jordão',
    role: 'Síndico - Múltiplos Condomínios',
    content: 'Excelente custo-benefício e financiamento facilitado. A comunicação durante toda a obra foi impecável.',
    rating: 5,
    project: 'Reforma Completa'
  },
  {
    id: 5,
    name: 'Marcia Cardoso',
    role: 'Síndica - Múltiplos Condomínios',
    content: 'Equipe própria e qualificada, segurança em primeiro lugar. Diário de obra digital facilitou muito o acompanhamento.',
    rating: 5,
    project: 'Manutenção Predial'
  },
  {
    id: 6,
    name: 'Anderson Arcindo',
    role: 'Síndico - Múltiplos Condomínios',
    content: 'Tecnologia de ponta e equipamentos modernos. Resultado final ficou excelente, dentro do prazo estabelecido.',
    rating: 5,
    project: 'Reforma de Fachada'
  },
  {
    id: 7,
    name: 'Illana Tenembaum',
    role: 'Síndica - Múltiplos Condomínios',
    content: 'Transparência total em cada etapa. Financiamento próprio ajudou muito na aprovação da obra. Recomendo!',
    rating: 5,
    project: 'Impermeabilização'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'Por que a LUVCORP só trabalha com tinta emborrachada?',
    answer: 'A LUVCORP prioriza a durabilidade e a proteção das fachadas. A tinta emborrachada oferece maior elasticidade, acompanhando pequenas movimentações da estrutura e reduzindo o reaparecimento de fissuras, além de proporcionar melhor impermeabilização da superfície.'
  },
  {
    id: 2,
    question: 'Quais os benefícios da tinta emborrachada?',
    answer: 'Maior elasticidade e flexibilidade • Redução de trincas e fissuras aparentes • Melhor impermeabilização da fachada • Maior vida útil da pintura • Melhor desempenho em fachadas expostas ao sol e à chuva'
  },
  {
    id: 3,
    question: 'É obrigatório realizar o teste de percussão?',
    answer: 'Embora nem sempre seja explicitamente obrigatório, o teste de percussão é fortemente recomendado e considerado uma boa prática técnica em reformas de fachada, pois permite identificar riscos ocultos antes do início da obra.'
  },
  {
    id: 4,
    question: 'O que é o teste de percussão e quais os benefícios?',
    answer: 'O teste de percussão consiste em percutir a superfície da fachada para identificar áreas com som cavo, indicando possível descolamento de reboco ou revestimento. Benefícios: Identificação prévia de riscos • Prevenção de acidentes • Definição correta do escopo da obra • Evita custos inesperados durante a execução'
  },
  {
    id: 5,
    question: 'Quais os benefícios de lavar os vidros da fachada?',
    answer: 'Melhora da estética do edifício • Remoção de resíduos agressivos ao vidro • Aumento da vida útil dos materiais • Valorização da imagem do condomínio'
  },
  {
    id: 6,
    question: 'Quais precauções a LUVCORP adota em relação ao uso de drones?',
    answer: 'A LUVCORP segue rigorosamente a legislação vigente, incluindo normas da ANAC, DECEA e ANATEL, utilizando drones registrados, operadores habilitados e respeitando limites de segurança, privacidade e áreas permitidas para voo.'
  },
  {
    id: 7,
    question: 'A LUVCORP trabalha com isolamento completo para serviços internos?',
    answer: 'Sim. Sempre que necessário, a LUVCORP realiza o isolamento adequado das áreas internas, protegendo moradores, patrimônio e garantindo segurança durante a execução dos serviços.'
  },
  {
    id: 8,
    question: 'A LUVCORP possui equipe própria ou terceirizada?',
    answer: 'A LUVCORP trabalha com equipe própria e especializada, treinada para atuar em reformas e manutenção predial, seguindo procedimentos técnicos, normas de segurança e padrões de qualidade.'
  },
  {
    id: 9,
    question: 'Por que devo fixar as pedras de granito da fachada com parafusos?',
    answer: 'A fixação mecânica com parafusos aumenta significativamente a segurança da fachada, reduzindo o risco de desprendimento das pedras, principalmente em edificações antigas ou expostas a intempéries.'
  },
  {
    id: 10,
    question: 'Quanto tempo leva a realização de um teste de percussão?',
    answer: 'O tempo varia conforme o tamanho da fachada, mas normalmente o teste pode ser realizado em poucos dias, sem interferir significativamente na rotina do condomínio.'
  },
  {
    id: 11,
    question: 'O que a norma diz sobre o olhal de ancoragem?',
    answer: 'As normas técnicas e regulamentações de segurança do trabalho exigem que sistemas de ancoragem sejam projetados e instalados de forma adequada para garantir a segurança dos trabalhadores em atividades em altura.'
  },
  {
    id: 12,
    question: 'Por que devo instalar olhal de ancoragem?',
    answer: 'Garante segurança para trabalhos em altura • Permite manutenção futura da fachada • Atende às exigências legais e normativas • Reduz riscos trabalhistas e acidentes'
  },
  {
    id: 13,
    question: 'Por que algumas empresas trabalham com contrapeso? É seguro? Como a LUVCORP trabalha?',
    answer: 'O uso de contrapeso pode apresentar riscos se não for corretamente dimensionado e instalado. A LUVCORP não utiliza contrapeso, optando por sistemas de ancoragem seguros e certificados, priorizando a segurança dos profissionais e do condomínio.'
  },
  {
    id: 14,
    question: 'Qual é o processo correto de lavagem de fachadas?',
    answer: 'A LUVCORP utiliza um processo técnico que inclui: Aplicação controlada de solução com cloro diluído a 15%, quando indicado • Tempo de ação adequado • Lavagem com hidrojateamento de baixa pressão, evitando danos à superfície. Esse método garante limpeza eficiente sem comprometer o revestimento.'
  },
  {
    id: 15,
    question: 'Qual método a LUVCORP utiliza para o diário de obra?',
    answer: 'O acompanhamento da obra é feito por meio de diário de obra digital, utilizando grupo exclusivo no WhatsApp, com registros fotográficos, atualizações frequentes e comunicação direta com o síndico ou responsável.'
  },
  {
    id: 16,
    question: 'É necessário fazer projeto para dreno de ar-condicionado?',
    answer: 'Sim. O projeto de dreno é fundamental para garantir o correto direcionamento da água, evitando infiltrações, manchas na fachada e problemas futuros.'
  },
  {
    id: 17,
    question: 'Quais os benefícios do dreno de ar-condicionado?',
    answer: 'Evita infiltrações e umidade • Preserva a fachada • Melhora o aspecto estético • Atende às exigências legais'
  },
  {
    id: 18,
    question: 'O que a lei diz sobre o dreno de ar-condicionado?',
    answer: 'A legislação e normas municipais geralmente exigem que a água do dreno seja corretamente direcionada para a rede adequada, sendo proibido o lançamento direto sobre fachadas, calçadas ou áreas comuns.'
  },
  {
    id: 19,
    question: 'Qual o período recomendado de manutenção do dreno de ar-condicionado?',
    answer: 'A manutenção deve ser feita periodicamente, preferencialmente uma vez por ano, ou sempre que houver sinais de entupimento, vazamento ou manchas na fachada.'
  }
];